import { render, staticRenderFns } from "./MoveCardUpDown.vue?vue&type=template&id=8e928410&"
import script from "./MoveCardUpDown.vue?vue&type=script&lang=js&"
export * from "./MoveCardUpDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e928410')) {
      api.createRecord('8e928410', component.options)
    } else {
      api.reload('8e928410', component.options)
    }
    module.hot.accept("./MoveCardUpDown.vue?vue&type=template&id=8e928410&", function () {
      api.rerender('8e928410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/MoveCardUpDown.vue"
export default component.exports